import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class OrganisationProfileCommitteeApiService extends ApiService {
  readonly resourcePath = 'organisation_profile_joint_committees';
 
  update(id: string, data: object): Observable<any> {
    return this.restUpdate<any>(id, data);
  }

  create(data:object){
    return this.restCreate<any>(data);
  }
  
  delete(id:string){
    return this.restDelete(id);
  }
  
}
